import { render, staticRenderFns } from "./regionManage.vue?vue&type=template&id=483133bf&"
import script from "./regionManage.vue?vue&type=script&lang=js&"
export * from "./regionManage.vue?vue&type=script&lang=js&"
import style0 from "./regionManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports